<template>
  <div class="container">
    <div class="text-container">
      <p class="text1">Page Not Found</p>
      <p class="text2">Sorry!! The page you requested doesn't exit.</p>
      <p class="text3">
        You can go back to
        <button
          @click="goHome"
          class="btn-link"
        >
          homepage.
        </button>
      </p>
    </div>
    <div>
      <img class="image-404" src="../assets/404page.svg" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$router.push("/Home");
    },
  },
};
</script>

<style>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: normal;
}

.image-404 {
  padding-top: 80px;
  width: 625px;
  height: 555px;
  transform: rotate(10deg);
}

.btn-link {
  width: 106px;
  color: #e9952a;
  font-size: 20px;
}

.text1 {
  font-size: 90px;
  color: #e9952a;
  font-weight: 700;
  letter-spacing: -11px;
  line-height: 1.5;
}

.text2 {
  color: rgb(255, 255, 255);
  font-size: 20px;
}

.text3 {
  color: rgb(255, 255, 255);
  font-size: 20px;
}
</style>